import type { RenderElementProps } from 'slate-react'

export default function TableCell({
  attributes,
  children,
}: RenderElementProps) {
  return (
    <td className="border !px-2 !py-1" {...attributes}>
      {children}
    </td>
  )
}
